import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className='loading-spinner-overlay'>
      <div className='spinner-container'>
        <div className='spinner'></div>
        <p className='loading-text'>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
